import { Spinner } from '@helix-ds/react'
import React from 'react'

export type LoadingSpinnerProps = {
  label?: string
}

// Rendered above IntlProvider (e.g. LocaleGate while preferences load), so it cannot call useIntl.
// Callers inside the i18n tree should pass a translated label via intl.formatMessage(...).
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ label = 'Loading…' }) => {
  return (
    <div className="bg-bg-secondary flex min-h-screen items-center justify-center">
      <div className="bg-background-primary border-border-base flex items-center gap-3 rounded-xl border px-4 py-3 shadow-sm">
        <Spinner color="info" size="sm" aria-hidden="true" />
        <div className="text-text-body text-sm">{label}</div>
      </div>
    </div>
  )
}

export default LoadingSpinner
